module.exports = __webpack_public_path__ + "img/cc_logo.bb0751ff.svg";